export default function CommunityParticipationSection() {
  const participations = [
    {
      title: "기술 교육",
      subtitle: "봉제 기술 전수 프로그램",
      description: "전문 봉제 기술을 배우고 자립의 기반을 만들어갑니다",
      programs: [
        {
          name: "기초 봉제 과정",
          duration: "3개월",
          content: "재봉틀 기초부터 실전 작업까지"
        },
        {
          name: "패턴 제작 과정",
          duration: "4개월",
          content: "의류 패턴 설계 및 제작 기술"
        },
        {
          name: "산업용 봉제 과정",
          duration: "6개월",
          content: "고급 봉제 기술 및 산업 현장 실무"
        }
      ],
      image: "https://public.readdy.ai/ai/img_res/d8f318ac1181803d1950e9704f9548e6.jpg"
    },
    {
      title: "공방 네트워크",
      subtitle: "지역 봉제 공방 협력",
      description: "전국의 봉제 공방과 함께 지속가능한 생산 네트워크를 구축합니다",
      programs: [
        {
          name: "공방 등록",
          duration: "상시",
          content: "지역 봉제 공방 네트워크 참여"
        },
        {
          name: "기술 공유",
          duration: "월 1회",
          content: "공방 간 기술 교류 및 워크숍"
        },
        {
          name: "공동 프로젝트",
          duration: "프로젝트별",
          content: "협업 생산 및 공동 수주"
        }
      ],
      image: "https://readdy.ai/api/search-image?query=local%20sewing%20workshop%20network%20multiple%20craftspeople%20working%20together%20community%20workspace%20shared%20resources%20collaborative%20production%20natural%20wood%20interior%20warm%20atmosphere%20sustainable%20craft%20community&width=800&height=600&seq=partnership-network&orientation=landscape"
    }
  ];

  return (
    <section className="py-32 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-[#2C3E2E] mb-6">공동체 참여</h2>
          <p className="text-xl text-[#5A6B5C] max-w-2xl mx-auto">
            기술을 나누고 함께 성장하는 공동체에 참여하세요
          </p>
        </div>

        <div className="space-y-32">
          {participations.map((participation, index) => (
            <div key={index}>
              <div className="grid lg:grid-cols-2 gap-12 items-center mb-12">
                <div className={index % 2 === 0 ? 'lg:order-1' : 'lg:order-2'}>
                  <div className="relative h-[500px] rounded-lg overflow-hidden">
                    <img
                      src={participation.image}
                      alt={participation.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
                
                <div className={index % 2 === 0 ? 'lg:order-2' : 'lg:order-1'}>
                  <h3 className="text-4xl font-bold text-[#2C3E2E] mb-3">
                    {participation.title}
                  </h3>
                  <p className="text-2xl text-[#7A9B76] mb-6 font-medium">
                    {participation.subtitle}
                  </p>
                  <p className="text-lg text-[#5A6B5C] leading-relaxed">
                    {participation.description}
                  </p>
                </div>
              </div>

              <div className="grid md:grid-cols-3 gap-8">
                {participation.programs.map((program, idx) => (
                  <div 
                    key={idx}
                    className="bg-[#FDFBF7] p-8 rounded-lg border border-[#E8E4DC] hover:border-[#7A9B76] transition-colors cursor-pointer"
                  >
                    <h4 className="text-2xl font-bold text-[#2C3E2E] mb-3">
                      {program.name}
                    </h4>
                    <div className="text-sm text-[#7A9B76] font-medium mb-4 uppercase tracking-wide">
                      {program.duration}
                    </div>
                    <p className="text-[#5A6B5C] leading-relaxed">
                      {program.content}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-24 text-center">
          <div className="inline-block bg-[#2C3E2E] text-white px-12 py-5 rounded-lg hover:bg-[#3D5240] transition-colors cursor-pointer">
            <span className="text-lg font-medium whitespace-nowrap">참여 문의하기</span>
          </div>
        </div>
      </div>
    </section>
  );
}